import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
const BlogCategoriesList = () => {
  const allData = useStaticQuery(graphql`
    query {
      allWpCategory {
        nodes {
          parentId
          id
          name
          uri
        }
      }
    }
  `)
  const categories = allData.allWpCategory.nodes
  const HelpCatParentId = "dGVybToxMTc="
  const BlogCatParentId = "dGVybTox"
  const filteredHelpCategories = categories.filter(
    (category) => category.parentId === HelpCatParentId
  )
  const filteredBlogCategories = categories.filter(
    (category) => category.parentId === BlogCatParentId
  )
  if (categories.length <= 0) {
    return <></>
  }
  return (
    <div className="mt-6 mt-md-0 col-lg-4 col-md-5">
      <div className="mhkb-mainpage__sidebar">
        <div
          id="ht-kb-articles-widget-2"
          className="widget mhkb_widget_articles"
        >
          <h3 className="widget-title">Knowledge Topic Categories</h3>
          <ul>
            {filteredHelpCategories.map((category) => {
              return (
                <>
                  <li key={category.uri}>
                    <Link
                      itemProp="url"
                      to={category.uri}
                      title={category.name}
                    >
                      {category.name}
                    </Link>
                  </li>
                </>
              )
            })}
          </ul>
        </div>
      </div>
      <div className="mhkb-mainpage__sidebar">
        <div
          id="ht-kb-articles-widget-2"
          className="widget mhkb_widget_articles"
        >
          <h3 className="widget-title">Blog Topic Categories</h3>
          <ul>
            {filteredBlogCategories.map((category) => {
              return (
                <>
                  <li key={category.uri}>
                    <Link
                      itemProp="url"
                      to={category.uri}
                      title={category.name}
                    >
                      {category.name}
                    </Link>
                  </li>
                </>
              )
            })}
          </ul>
        </div>
      </div>
      <div className="mhkb-sticky">
        <div id="ht-kb-exit-widget-2" className="widget mhkb_widget_exit">
          <h3 className="widget-title">Need Support?</h3>
          <div className="mhkb_widget_exit__content">
            Can't find the answer you're looking for? Don't worry we're here to
            help!
          </div>
          <a
            rel="noreferrer"
            className="mhkb_widget_exit__btn"
            href="https://my.motherhost.com/submitticket.php?step=2&deptid=2"
            target="_blank"
          >
            Contact Support
          </a>
        </div>
      </div>
    </div>
  )
}

export default BlogCategoriesList
